/**
 * SKU表单组件
 * 职责: SKU创建/编辑表单
 * 限制: <100行
 */

import React from 'react';
import { Form, Input, InputNumber } from 'antd';
import type { FormInstance } from 'antd';
import { skuFormRules } from './validation';

interface SKUFormProps {
    form: FormInstance;
    onFinish: (values: any) => void;
}

export const SKUForm: React.FC<SKUFormProps> = ({ form, onFinish }) => {
    return (
        <Form
            form={form}
            layout="vertical"
            onFinish={onFinish}
        >
            <Form.Item
                name="name"
                label="SKU名称"
                rules={skuFormRules.name}
            >
                <Input placeholder="请输入SKU名称" />
            </Form.Item>

            <Form.Item
                name="asin"
                label="ASIN"
                rules={skuFormRules.asin}
            >
                <Input placeholder="请输入ASIN（10位）" maxLength={10} />
            </Form.Item>

            <Form.Item
                name="description"
                label="描述"
            >
                <Input.TextArea rows={4} placeholder="请输入描述（可选）" />
            </Form.Item>

            <Form.Item
                name="price"
                label="售价（美元）"
                rules={skuFormRules.price}
            >
                <InputNumber
                    prefix="$"
                    precision={2}
                    style={{ width: '100%' }}
                    placeholder="请输入产品售价"
                    min={0}
                />
            </Form.Item>

            <Form.Item
                name="profit_margin"
                label="定价利润率（%）"
                rules={skuFormRules.profit_margin}
                tooltip="定价利润率 = (售价 - 成本 - FBA费用) / 售价 × 100%"
            >
                <InputNumber
                    suffix="%"
                    precision={2}
                    style={{ width: '100%' }}
                    placeholder="请输入利润率"
                    min={0}
                    max={100}
                />
            </Form.Item>

            <Form.Item
                name="target_market"
                label="目标市场/客户群"
                tooltip="描述产品的目标客户特征"
            >
                <Input.TextArea
                    rows={3}
                    placeholder="请描述目标客户群体特征"
                />
            </Form.Item>

            <Form.Item
                name="key_selling_points"
                label="核心卖点"
                tooltip="产品的主要竞争优势"
            >
                <Input.TextArea
                    rows={3}
                    placeholder="请列出产品的核心竞争优势"
                />
            </Form.Item>
        </Form>
    );
};
